import { render, staticRenderFns } from "./Category_view.vue?vue&type=template&id=075abea9&scoped=true&"
import script from "./Category_view.vue?vue&type=script&lang=js&"
export * from "./Category_view.vue?vue&type=script&lang=js&"
import style0 from "./Category_view.vue?vue&type=style&index=0&id=075abea9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075abea9",
  null
  
)

export default component.exports